import { getToken, rolesOptions, statesOptions } from "helper/common";
import {
    CLEAR_USER_DETAILS,
    CLEAR_USER_LIST,
    SET_USER_DETAILS,
    SET_USER_FILTER_DATA,
    SET_USER_LIST,
    USER_CREATE_DIALOG_CLOSE,
    USER_CREATE_DIALOG_OPEN,
    USER_CREATE_ERROR,
    USER_CREATE_ERROR_CLEAR,
    USER_CREATE_PENDING,
    USER_DETAILS_ERROR,
    USER_DETAILS_ERROR_CLEAR,
    USER_DETAILS_PENDING,
    USER_EDIT_DIALOG_CLOSE,
    USER_EDIT_DIALOG_OPEN,
    USER_EDIT_ERROR,
    USER_EDIT_ERROR_CLEAR,
    USER_EDIT_PENDING,
    USER_FILTER_DIALOG_CLOSE,
    USER_FILTER_DIALOG_OPEN,
    USER_LIST_ERROR,
    USER_LIST_ERROR_CLEAR,
    USER_LIST_PENDING,
    USER_PASSWORD_RESET_ERROR,
    USER_PASSWORD_RESET_ERROR_CLEAR,
    USER_PASSWORD_RESET_PENDING,
    USER_PASSWORD_RESET_SUCCESS
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";
import { getProfile } from "../authentication/login/actions";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setUserList = (userList) => ({
    type: SET_USER_LIST,
    payload: { userList }
});

export const clearUserList = () => ({
    type: CLEAR_USER_LIST,
});

export const userListPending = () => ({
    type: USER_LIST_PENDING
});

export const userListError = (errorMessage) => ({
    type: USER_LIST_ERROR,
    payload: { errorMessage }
});

export const userListErrorClear = () => ({
    type: USER_LIST_ERROR_CLEAR
});

export const getUserList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(userListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.users.getUserList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((userList) => {
                dispatch(setUserList(userList));
                dispatch(userListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(userListError(message));
                }
                else {
                    dispatch(userListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openUserFilterDialog = () => ({
    type: USER_FILTER_DIALOG_OPEN
});

export const closeUserFilterDialog = () => ({
    type: USER_FILTER_DIALOG_CLOSE
});

export const setUserFilteredData = (filter) => ({
    type: SET_USER_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setUserDetails = (userDetails) => ({
    type: SET_USER_DETAILS,
    payload: { userDetails }
});

export const clearUserDetails = () => ({
    type: CLEAR_USER_DETAILS,
});

export const userDetailsPending = () => ({
    type: USER_DETAILS_PENDING
});

export const userDetailsError = (errorMessage) => ({
    type: USER_DETAILS_ERROR,
    payload: { errorMessage }
});

export const userDetailsErrorClear = () => ({
    type: USER_DETAILS_ERROR_CLEAR
});

export const getUserDetails = (id) => (dispatch) => {
    dispatch(userDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.users.getUserDetails(accessToken, id)
            .then((userDetails) => {
                dispatch(setUserDetails(userDetails));
                dispatch(userDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(userDetailsError(message));
                }
                else {
                    dispatch(userDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| RESET USER PASSWORD ||---------------------------------------------------------------
export const resetUserPasswordPending = () => ({
    type: USER_PASSWORD_RESET_PENDING,
});
export const resetUserPasswordError = (errorMessage) => ({
    type: USER_PASSWORD_RESET_ERROR,
    payload: { errorMessage }
});
export const resetUserPasswordErrorClear = () => ({
    type: USER_PASSWORD_RESET_ERROR_CLEAR,
});
export const resetUserPasswordSuccess = () => ({
    type: USER_PASSWORD_RESET_SUCCESS,
});

export const resetUserPassword = (email) => (dispatch) => {
    dispatch(resetUserPasswordPending());
    return agent.authentication.forgotPassword(email)
        .then(() => {
            dispatch(resetUserPasswordSuccess());
            dispatch(resetUserPasswordErrorClear());
            dispatch(openSnackbar({
                open: true,
                message: "Password reset link send to respective user's email.",
                variant: 'alert',
                close: true
            }));
        })
        .catch((err) => {
            if (err?.status) {
                let message;
                const { response } = err;
                if (response?.body) {
                    message = response.body;
                }
                else if (response?.text) {
                    message = response.text;
                }
                else {
                    message = null;
                }
                dispatch(resetUserPasswordError(message));
                dispatch(openSnackbar({
                    open: true,
                    message: "Can't reset password. Try again.",
                    variant: 'alert',
                    close: true
                }));
            }
            else {
                dispatch(resetUserPasswordError(":( Network Error"));
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            }
        })
}

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openUserCreateDialog = () => ({
    type: USER_CREATE_DIALOG_OPEN
});

export const closeUserCreateDialog = () => ({
    type: USER_CREATE_DIALOG_CLOSE
});

export const userCreatePending = () => ({
    type: USER_CREATE_PENDING
});

export const userCreateError = (errorMessage) => ({
    type: USER_CREATE_ERROR,
    payload: { errorMessage }
});

export const userCreateErrorClear = () => ({
    type: USER_CREATE_ERROR_CLEAR
});

export const userCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(userCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.users.userCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getUserList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(userCreateErrorClear());
                dispatch(closeUserCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'User successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(userCreateError(message));
                }
                else {
                    dispatch(userCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

export const getRoleOptions = (filter) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.users.getRoles(accessToken, filter)
            .then((roles) => {
                const options = rolesOptions(roles['value']);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    console.err(message)
                }
                return Promise.reject();
            })
    })
}

export const getSelectedStates = (filter) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.users.getSelectedStates(accessToken, filter)
            .then((states) => {
                const options = statesOptions(states['value']);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    console.error(message)
                }
                return Promise.reject();
            })
    })
}
//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openUserEditDialog = () => ({
    type: USER_EDIT_DIALOG_OPEN
});

export const closeUserEditDialog = () => ({
    type: USER_EDIT_DIALOG_CLOSE
});

export const userEditPending = () => ({
    type: USER_EDIT_PENDING
});

export const userEditError = (errorMessage) => ({
    type: USER_EDIT_ERROR,
    payload: { errorMessage }
});

export const userEditErrorClear = () => ({
    type: USER_EDIT_ERROR_CLEAR
});

export const userEdit = (formData, userId, navigate) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(userEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.users.userEdit(accessToken, dataToSend)
            .then(() => {
                if ((userId === formData?.id)) {
                    const labRoles = ["Lab Admin", "Lab User"]
                    if (labRoles?.includes(formData?.userRoleName))
                        navigate("/lab-records/list")
                    else if (formData?.userRoleName === "User") {
                        navigate("/dashboard")
                    }
                    else {
                        return null;
                    }
                }
                dispatch(getUserDetails(formData?.id));
                dispatch(getProfile());
                dispatch(userEditErrorClear());
                dispatch(closeUserEditDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'User details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(userEditError(message));
                }
                else {
                    dispatch(userEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
